import {
  Box,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useRef } from "react";
import { ButtonsActions, NewProjectContext } from "../../pages/newProject";
import EuroIcon from "@mui/icons-material/Euro";
import PercentIcon from "@mui/icons-material/Percent";

function SecondStep() {
  const { newCreateData, setNewCreateData, showSnack } =
    useContext(NewProjectContext);

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");

    return rawValue;
  };

  const checkIsZero = (field, value) => {
    if (value.startsWith("0")) {
      showSnack(`${field} no puede ser 0`);
      return true;
    }

    return false;
  };

  return (
    <Stack component="section">
      <Stack mb={2}>
        <Typography component="h3" variant="h6" mb={2}>
          Beneficiones de inversores
        </Typography>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={4}
          mb={2}
        >
          <TextField
            label="Capital mínimo ofrecido"
            required
            value={formatNumberWithDots(newCreateData.min_offered_capital)}
            onChange={({ target }) => {
              const isZero = checkIsZero(
                "Capital mínimo ofrecido",
                target.value
              );
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  min_offered_capital: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Capital máximo ofrecido"
            required
            value={formatNumberWithDots(newCreateData.max_offered_capital)}
            onChange={({ target }) => {
              const isZero = checkIsZero(
                "Capital máximo ofrecido",
                target.value
              );
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  max_offered_capital: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>


        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={4}
          mb={2}
        >
          <TextField
            label="Mínimo retorno de inversión"
            required
            value={formatNumberWithDots(newCreateData.min_return_investment)}
            onChange={({ target }) => {
              const isZero = checkIsZero(
                "Mínimo retorno de inversión",
                target.value
              );
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  min_return_investment: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Máximo retorno de inversión"
            required
            value={formatNumberWithDots(newCreateData.max_return_investment)}
            onChange={({ target }) => {
              const isZero = checkIsZero(
                "Máximo retorno de inversión",
                target.value
              );
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  max_return_investment: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>


        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={4}
        >
          <TextField
            label="Participaciones mínimas a dar"
            required
            value={formatNumberWithDots(newCreateData.min_stake)}
            onChange={({ target }) => {
              const isZero = checkIsZero("Participaciones mínimas a dar", target.value);
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);
                setNewCreateData({
                  ...newCreateData,
                  min_stake: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Participaciones máximas a dar"
            required
            value={formatNumberWithDots(newCreateData.max_stake)}
            onChange={({ target }) => {
              const isZero = checkIsZero("Participaciones máximas a dar", target.value);
              if (isZero) {
                return;
              }

              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);
                setNewCreateData({
                  ...newCreateData,
                  max_stake: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>



        <Box
          display="flex"
          mt={2}
          flexDirection={{ xs: "column", md: "row" }}
          gap={4}
        >
          <TextField
            label="Garantía inmobiliaria"
            value={formatNumberWithDots(
              newCreateData?.warranty_inmobiliaria || ""
            )}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  warranty_inmobiliaria: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Garantía económica"
            value={formatNumberWithDots(
              newCreateData?.warranty_economica || ""
            )}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  warranty_economica: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>
      </Stack>
      <Stack>
        <Typography component="h3" variant="h6" mb={2}>
          Destino de inversión
        </Typography>

        <Box
          flexDirection={{ xs: "column", md: "row" }}
          display="flex"
          gap={4}
          mb={2}
        >
          <TextField
            label="Minimo invertido marketing"
            required
            value={formatNumberWithDots(newCreateData?.min_marketing)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  min_marketing: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Máximo invertido marketing"
            required
            value={formatNumberWithDots(newCreateData.max_marketing)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  max_marketing: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>
        <Box flexDirection={{ xs: "column", md: "row" }} display="flex" gap={4}>
          <TextField
            label="Minimo invertido construcción"
            required
            value={formatNumberWithDots(newCreateData.min_construction)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  min_construction: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
          <TextField
            label="Máximo invertido construcción"
            required
            value={formatNumberWithDots(newCreateData.max_construction)}
            onChange={({ target }) => {
              let result = handleChange(target.value);
              if (/^\d*$/.test(result)) {
                result = result.slice(0, 10);

                setNewCreateData({
                  ...newCreateData,
                  max_construction: result,
                });
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <EuroIcon />
                </InputAdornment>
              ),
            }}
            type="text"
            fullWidth
          />
        </Box>
      </Stack>
      <ButtonsActions last={true} />
    </Stack>
  );
}

export default SecondStep;
